import { IHwTypeBase } from '@dto/architecture.dto';
import { BaseDeviceProps } from "@hostcfgs/deviceProps";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppGlobStore } from 'src/appGlobalStore';
import { ColProps, GridProps } from "src/component/grid/gridTypes";
import { RoutePath } from 'src/data/Routes';
import { GridScope } from '../../../component/grid/Grid';
import { HostCfgItem } from './ConfigurationTypes';

interface TableConfigurationProps<P extends BaseDeviceProps = BaseDeviceProps> {
  columns: ColProps<HostCfgItem<P>>[];
  dataSource: readonly HostCfgItem<P>[];
  subTypeLimit?: {
    limit: number;
    hwType: IHwTypeBase;
    key: string;
  };
  onChange?: GridProps<HostCfgItem<P>>['onChange'];
  topOffset?: number;
  _key?: string;
}

export default function TableConfiguration<P extends BaseDeviceProps = BaseDeviceProps>(props: Readonly<TableConfigurationProps<P>>) {

  const { columns, dataSource, subTypeLimit, topOffset, _key } = props;
  const [gs] = useState(() => new GridScope<HostCfgItem<P>>('plain'));
  const info = useAppGlobStore(state => state.info);

  return <div>
    <gs.Grid className='xm-table-fill'
      noScrollY
      dataSource={dataSource}
      renderProps={{ noClipboard: true }}
      pagination={false}
      style={{ position: "relative", left: "0px" }}
      onRow={record => ({ className: (record.disabled ? 'text-gray ' : '') + (record.limited ? 'text-danger' : '') })}
      columns={columns}
      onChange={props.onChange}
      topOffset={topOffset}
      key={_key}
    />
    {dataSource.some(hci => hci.limited) && <div className='xm-license-limit'>
      {info.backend.free ? <>
        <strong>Warning:</strong> Free Edition is limited to {dataSource.filter(hci => !hci.limited && !hci.disabled).length} active devices.<br />
        Consider upgrading to the <a href="https://xormon.com/support-ng.php" target="_blank">Enterprise Edition</a>.
      </>
        : subTypeLimit ? <>
          You have reached maximum number ({subTypeLimit.limit}) of {subTypeLimit.hwType.label} [{subTypeLimit.key}] covered by your license.<br />
          Please check <Link to={RoutePath.SETTINGS + RoutePath.HELP + RoutePath.LICENSE}>license</Link> or contact <Link to={RoutePath.SETTINGS + RoutePath.HELP + RoutePath.SUPPORT}>support</Link>.
        </>
          : <>
            <strong>License warning:</strong> You have reached the limit of active devices.<br />
            Please contact <Link to={RoutePath.SETTINGS + RoutePath.HELP + RoutePath.SUPPORT}>support</Link> if you need to add more devices.
          </>}
    </div>}
  </div>;
}
